import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = 'https://elitebet-api-production.up.railway.app/api';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for token in URL (from OAuth callback)
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    
    if (tokenFromUrl) {
      localStorage.setItem('elitebet_user_token', tokenFromUrl);
      // Clean URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // Check for existing token
    const token = localStorage.getItem('elitebet_user_token');
    
    if (token) {
      fetchUser(token);
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUser = async (token) => {
    try {
      const response = await fetch(`${API_URL}/auth/me`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const userData = await response.json();
        setUser(userData);
      } else {
        localStorage.removeItem('elitebet_user_token');
      }
    } catch (err) {
      console.error('Error fetching user:', err);
      localStorage.removeItem('elitebet_user_token');
    } finally {
      setLoading(false);
    }
  };

  const loginWithDiscord = () => {
    window.location.href = `${API_URL}/auth/discord`;
  };

  const loginWithGoogle = () => {
    window.location.href = `${API_URL}/auth/google`;
  };

  const logout = () => {
    localStorage.removeItem('elitebet_user_token');
    setUser(null);
  };

  const refreshUser = async () => {
    const token = localStorage.getItem('elitebet_user_token');
    if (token) {
      await fetchUser(token);
    }
  };

  return (
    <UserContext.Provider value={{ user, loading, loginWithDiscord, loginWithGoogle, logout, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
}

export const useUser = () => useContext(UserContext);
